import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectPathname } from 'src/redux/navigation/selectors';
import type { Facet } from 'src/redux/productsQuery/types/Facet';
import { deriveTaxonomyLevelsFromFacets } from './deriveTaxonomyLevelsFromFacets';

const encodeSegment = (segment: string): string =>
  segment.split(',').map(encodeURIComponent).join(',');

export const buildListingsBasePath = (routeLiteral: string, levels: string[]): string =>
  `/${[routeLiteral, ...levels].map(encodeSegment).join('/')}`;

export const selectListingsBasePath = (
  state: ReduxApplicationState,
  facets: Facet[] = state.productsQuery.facets,
): string => {
  const { taxonomyAttributeAliases = [] } = state.productsQuery;
  const pathname = selectPathname(state) ?? '/';

  if (taxonomyAttributeAliases.length === 0) {
    return pathname;
  }

  const routeLiteral = pathname.split('/').filter((s) => s.length > 0)[0] ?? '';
  const levels = deriveTaxonomyLevelsFromFacets(facets, taxonomyAttributeAliases);
  return buildListingsBasePath(routeLiteral, levels);
};
